export default __webpack_public_path__ + "static/media/icon-fermeture-tag.181af96c.svg";